import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";

export default function RecoveryBanner() {
  const [status, setStatus] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    api.get("/auth/recovery-status").then((r) => setStatus(r.data)).catch(() => {});
  }, [pathname]);

  if (!status || status.remaining > 0 || pathname === "/admin/settings") return null;

  return (
    <div data-testid="recovery-banner" className="mb-6 flex flex-col sm:flex-row sm:items-center gap-3 bg-[#FBEBDD] border border-[#E8C9A8] text-[#7A4A1D] rounded-2xl px-4 py-3 text-xs">
      <ShieldAlert className="w-4 h-4 shrink-0" />
      <span className="flex-1">
        {status.has_codes ? "Semua kode pemulihan sudah terpakai." : "Anda belum membuat kode pemulihan."} Tanpa kode ini akun admin bisa terkunci jika lupa kata sandi.
      </span>
      <Link to="/admin/settings" data-testid="recovery-banner-link" className="font-bold underline hover:text-[#5A3410] whitespace-nowrap">
        Buat kode sekarang →
      </Link>
    </div>
  );
}
